import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { AudioPlayer } from '@gem/ui-kit';

import { useMiniAudioPlayerPresenter } from './MiniAudioPlayer.presenter';
import styles from './MiniAudioPlayer.styles.m.css';

export const MiniAudioPlayer: FC = observer(() => {
  const presenter = useMiniAudioPlayerPresenter();

  const { t } = useTranslation();

  if (!presenter.isOpened) {
    return null;
  }

  return (
    <AudioPlayer
      className={styles.audioPlayer}
      autoPlay={true}
      isPlaying={presenter.isPlaying}
      track={presenter.track || undefined}
      playerConfig={presenter.config}
      onConfigUpdate={presenter.onConfigUpdate}
      isShowPlayList={presenter.isShowPlayList}
      playList={presenter.playList}
      isShowOrder={presenter.isShowOrder}
      isShowRepeat={presenter.isShowRepeat}
      progress={presenter.newProgress}
      progressPercentage={presenter.newProgressPercentage}
      onChangeTrack={presenter.onChangeTrack}
      onProgress={presenter.onProgress}
      onTogglePlay={presenter.onTogglePlay}
      onTitleClick={presenter.onTitleClick}
      onClose={presenter.onClose}
      speedTooltipText={t('audio_player_tooltip_speed')}
    />
  );
});
